import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useMarket } from "#/contexts/MarketContext";
import {
  useGetOrderDayCallbacks,
  useGetOrderDayAnomalies,
  useGetCallbackCounters,
  useGetAnomalyCounters,
} from "#/lib/api/order-day";
import { OrderDayPage } from "#/components/pages/order-day/order-day-page";

export const Route = createFileRoute("/$tenantCode/$market/order-day")({
  beforeLoad: () => ({ getTitle: () => m["resources.orderDay.name"]() }),
  component: OrderDayIndex,
});

function OrderDayIndex() {
  const market = useMarket();
  const [activeTab, setActiveTab] = useState<"callbacks" | "anomalies">(
    "callbacks",
  );
  const [onlyUnchecked, setOnlyUnchecked] = useState<boolean>(
    sessionStorage.getItem("orderDay.onlyUnchecked") === "true",
  );

  const { data: callbacksData, isLoading: isCallbacksLoading } =
    useGetOrderDayCallbacks({
      market,
      onlyUnchecked,
    });
  const { data: anomaliesData, isLoading: isAnomaliesLoading } =
    useGetOrderDayAnomalies({
      market,
    });
  const { data: callbackCounters } = useGetCallbackCounters(
    market,
    activeTab === "callbacks",
  );
  const { data: anomalyCounters } = useGetAnomalyCounters(
    market,
    activeTab === "anomalies",
  );

  return (
    <OrderDayPage
      callbacks={callbacksData?.member ?? []}
      anomalies={anomaliesData?.member ?? []}
      callbackCounters={callbackCounters}
      anomalyCounters={anomalyCounters}
      isCallbacksLoading={isCallbacksLoading}
      isAnomaliesLoading={isAnomaliesLoading}
      market={market}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      onlyUnchecked={onlyUnchecked}
      onToggleUnchecked={() => {
        const newValue = !onlyUnchecked;
        setOnlyUnchecked(newValue);
        sessionStorage.setItem("orderDay.onlyUnchecked", String(newValue));
      }}
    />
  );
}
